import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { BaseApi } from './base/base-api';

@Injectable({
  providedIn: 'root',
})
export class ServiceApiService extends BaseApi {
  constructor() {
    super(environment.api + 'service');
  }

  public getImportLogfile(importId: string): Observable<Blob> {
    return this.http.get(this.baseUrl + `/import-logfile/${importId}`, {
      responseType: 'blob',
    });
  }
}
